import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import {
  getFTTBServiceDisconnectionDate,
  getFTTBServiceIsBlocked,
  getFTTBServiceRequestId,
} from 'pages/Internet/store/selectors';
import { cancelFutureRequest } from 'pages/Internet/store/actions';
import { getFTTBServiceIsDisconnectionRequestPending } from 'pages/Internet/store/selectors/servicesSelectors';
import { ConnectionDateStatus } from '../../../../components';

export const ServiceDisconnectionRequestStatus = compose(
  connect(
    (state) => ({
      isAllowed: !getFTTBServiceIsBlocked(state),
      namePath: 'internet.messages.disconnectionDate',
      linkText: 'Не отключать',
      requestId: getFTTBServiceRequestId(state),
      date: getFTTBServiceDisconnectionDate(state),
      shouldRender: !!getFTTBServiceIsDisconnectionRequestPending(state),
    }), { cancelFutureRequest },
  ), withRenderFlag,
)(ConnectionDateStatus);
